import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import ProgressPhoto from "@assets/icons/progressPhoto";
import { ROUTES } from "src/router/routes";

interface PhotoCardProps {
  imageUrl: string;
  fullVariant: string;
  variant: string;
  id: number;
}

const PhotoCard: React.FC<PhotoCardProps> = ({
  imageUrl,
  fullVariant,
  variant,
  id,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${ROUTES.CRO}/${ROUTES.CRO_PHOTOOPTIMISATION}/${id}`, {
      state: { imageUrl, fullVariant, variant },
    });
  };

  const handleUpdate = () => {
    navigate(`/${ROUTES.CRO}/${ROUTES.CRO_PHOTOUPDATE}/${id}`, {
      state: { imageUrl, fullVariant, variant },
    });
  };

  return (
    <div className={styles.photoCard}>
      <img src={imageUrl} alt="Product" className={styles.productImage} />
      <div className={styles.description}>
        <div className={styles.progressIcon}>
          <ProgressPhoto />
        </div>
        <div className={styles.textBlock}>
          <div className={styles.optimizationText}>
            Photo requires optimization
          </div>
        </div>
      </div>
      <div className={styles.score}>Score: 0</div>
      <div className={styles.actionButtons}>
        <button type="button" className={styles.details} onClick={handleClick}>
          see details
        </button>
        <button type="button" className={styles.update} onClick={handleUpdate}>
          update
        </button>
      </div>
    </div>
  );
};

export default PhotoCard;
